import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { ToastrService } from 'ngx-toastr';
import { FeatureCode } from 'projects/Autofacets-Core/src/app/utils/enums';
import { CurrentLanguage } from '../../../../../Autofacets-Core/src/app/common-services/current-language.service';
import { Features } from '../../business-entities/user-role-view-model';
import { UserDataService } from './../../../../../../src/app/DataServices/user-data.service';
import { BaseService } from './../../../../../Autofacets-Core/src/app/services/base.service';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';

@Injectable({
  providedIn: 'root',
})
export class UserStampGuard {
  isUserStampInOutActive: boolean;
  features: Features[] = [];
  constructor(
    private router: Router,
    private userService: UserDataService,
    private msalService: MsalService,
    private currentLanguageService: CurrentLanguage,
    private baseService: BaseService,
    private secureStorage: SecureStorage,
    private toaster: ToastrService
  ) {}
  canActivate(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    return this.canActivateChild(childRoute, state);
  }

  async canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    if (this.features?.length === 0) {
      this.features = this.secureStorage.getKeyData('feature');
      this.isUserStampInOutActive = this.features.find(
        (x) => x.featureCode === FeatureCode.UserStampInOut
      )?.isActive;
    }

    let hasAccess = false;
    this.baseService.userLoggedIn =
      this.currentLanguageService.userLoggedIn.getValue();

    if (this.baseService.userLoggedIn) {
      if (this.userService.currentUserValue === undefined) {
        return this.userService.GetUserDetails().then((_response) => {
          hasAccess = this.isUserStampInOutActive && this.userService.currentUserValue.isEnableStampIn
            ? this.userService.currentUserValue.stampIn
            : true;
          if (hasAccess) {
            return true;
          } else {
            this.toaster.warning(
              'Please stamp in first to access the application!'
            );
            return this.router.createUrlTree([`/dashboard`]);
          }
        });
      } else if (this.userService.currentUserValue !== null) {
        if (this.userService.currentUserValue.isCorrectRole) {
          hasAccess = this.isUserStampInOutActive && this.userService.currentUserValue.isEnableStampIn
            ? this.userService.currentUserValue.stampIn
            : true;
          if (hasAccess) {
            return true;
          } else {
            this.toaster.warning(
              'Please stamp in first to access the application!'
            );
            return this.router.createUrlTree([`/dashboard`]);
          }
        } else if (!this.userService.currentUserValue.isCorrectRole) {
          this.msalService.logout();
        }
      }
    }

    if (hasAccess) {
      return true;
    } else {
      return this.router.createUrlTree([`/`]);
    }
  }
}
